export class AddLabReportsModel {

   "studyId": Number;
    "userId": Number;
    "patientId": Number;
    "testName": String;
    "testValue": Number;
    "fileURL": String;

}